export default {
    pay: 'Go to payment',
    cost: {
        begin: 'it will cost you',
        end: 'rubles'
    },
    discount: 'discount',
    showInfo: 'show info',
    payError: 'Unable to pay, please try again later',
};
